import { getRoute } from './Route';
import { app } from '../app';
export var createRoutingConfig = function (routes) {
    return { routes: routes };
};
export var route = function (name, values) {
    return getRoute(app().routingConfig.routes, name, values);
};
